module.exports = __webpack_public_path__ + "img/icon-team-5.ff507ef6.svg";